import { Show } from '@/components/show'
import { Practitioner } from './types'
import { humanNameParts } from './utils'

export type PractitionerNameProps = Pick<Practitioner, 'name'>

export function PractitionerName({ name }: PractitionerNameProps) {
  const officialName = name?.find(n => n.use === 'official')
  const [officialFamily, officialGiven] = humanNameParts(officialName)

  return (
    <p className='font-medium'>
      <Show
        when={officialFamily}
        fallback={
          <span className='text-destructive'>No recorded Official name</span>
        }
      >
        <span className='font-bold'>{officialFamily}</span>
        <Show when={officialGiven}>, {officialGiven}</Show>
      </Show>
    </p>
  )
}

export function PractitionerUsualName({ name }: PractitionerNameProps) {
  const usualName = name?.find(n => n.use === 'usual')
  const [usualFamily, usualGiven] = humanNameParts(usualName)

  if (!usualFamily) return null

  return (
    <p className='text-muted-foreground text-xs font-medium'>
      <span className='font-bold'>{usualFamily}</span>
      <Show when={usualGiven}>, {usualGiven}</Show>
    </p>
  )
}
